import useCardHeaderValues from './use-card-header-values';
export default {
    useCardHeaderValues: useCardHeaderValues
};
//# sourceMappingURL=index.js.map